import { render, staticRenderFns } from "./AppOutlinedChip.vue?vue&type=template&id=da376594&scoped=true&"
import script from "./AppOutlinedChip.vue?vue&type=script&lang=js&"
export * from "./AppOutlinedChip.vue?vue&type=script&lang=js&"
import style0 from "./AppOutlinedChip.vue?vue&type=style&index=0&id=da376594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da376594",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
